<template>
  <div>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="">
        <b-row xl="12" sm="12">
          <b-col cols="6">
            <table class="w-100">
              <!-- <tr>
                <th>
                  <span class="font-weight-bold">{{userData.data.company.partner_name}}</span>
                </th>
              </tr> -->
              <tr>
                <th>
                  <span class="font-weight-bold">{{userData.data.companies.name}}</span>
                </th>
              </tr>
              <tr>
                <th>
                  <span class="font-weight-bold">{{userData.data.user_projects[0].projects.name}}</span>
                </th>
              </tr>
            </table>
          </b-col>
          <b-col cols="6">
            <table class="w-100">
              <tr>
                <th style="text-align:right">
                  <span class="font-weight-bold">{{datenow}}</span>
                </th>
              </tr>
            </table>
          </b-col>
        </b-row>
        <b-row xl="12" sm="12" style="display:none">
          <b-col cols="6">
            <table class="w-100">
              <tr>
                <th>
                  <span class="font-weight-bold">{{datenow}}</span>
                </th>
              </tr>
              <tr>
                <th>&nbsp;</th>
              </tr>
              <tr>
                <th>
                  <span class="font-weight-bold">{{userData.data.companies.partners.name}}</span>
                </th>
              </tr>
              <tr>
                <th>
                  <span class="font-weight-bold">{{userData.data.companies.name}}</span>
                </th>
              </tr>
              <tr>
                <th>
                  <span class="font-weight-bold">{{userData.data.user_projects[0].projects.name}}</span>
                </th>
              </tr>
            </table>
          </b-col>
          <b-col cols="2">
            <table class="w-100">
              <tr>
                <th>
                  <span class="font-weight-bold">Weather</span>
                </th>
              </tr>
              <tr>
                <th>&nbsp;</th>
              </tr>
              <tr>
                <th>
                  <span class="font-weight-bold">Location {{weather_name}}</span>
                </th>
              </tr>
              <tr>
                <th>
                  <span class="font-weight-bold">{{weather_main}}</span>
                </th>
              </tr>
              <tr>
                <th>
                  <span class="font-weight-bold">{{weather_description}}</span>
                </th>
              </tr>
            </table>
          </b-col>
          <b-col cols="2">
            <table class="w-100">
              <tr>
                <th>&nbsp;</th>
              </tr>
              <tr>
                <th>&nbsp;</th>
              </tr>
              <tr>
                <th>
                  <span class="font-weight-bold">Temperature</span>
                </th>
                <th>
                  <span class="font-weight-bold">{{weather_main_temp}}</span>
                </th>
              </tr>
              <tr>
                <th>
                  <span class="font-weight-bold">Feels Like</span>
                </th>
                <th>
                  <span class="font-weight-bold">{{weather_main_feels_like}}</span>
                </th>
              </tr>
              <tr>
                <th>
                  <span class="font-weight-bold">Humidity</span>
                </th>
                <th>
                  <span class="font-weight-bold">{{weather_main_humidity}} %RH</span>
                </th>
              </tr>
            </table>
          </b-col>
          <b-col cols="2">
            <table class="w-100">
              <tr>
                <th>&nbsp;</th>
              </tr>
              <tr>
                <th>&nbsp;</th>
              </tr>
              <tr>
                <th>
                  <span class="font-weight-bold">COD</span>
                </th>
                <th>
                  <span class="font-weight-bold">{{weather_cod}}</span>
                </th>
              </tr>
              <tr>
                <th>
                  <span class="font-weight-bold">Pressure</span>
                </th>
                <th>
                  <span class="font-weight-bold">{{weather_main_pressure}} mmHg</span>
                </th>
              </tr>
              <tr>
                <th>
                  <span class="font-weight-bold">Visibility</span>
                </th>
                <th>
                  <span class="font-weight-bold">{{weather_visibility}}</span>
                </th>
              </tr>
            </table>
          </b-col>
        </b-row>
      </b-card>
      <b-card title="Summary">
        <b-row>
          <b-col xl="12" sm="12">
            <b-row>
              <b-col
                v-for="item in data"
                :key="item.icon"
                xl="3"
                sm="6"
                :class="item.customClass"
              >
                <b-media no-body>
                  <b-media-aside

                    class="mr-2"
                  >
                    <b-avatar
                      size="48"
                      :variant="item.color"
                    >
                      <b-img :src="item.icons"/>
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto" style="text-align: center;">
                    <h4 class="font-weight-bolder mb-0">
                      {{ item.subtitle }}
                    </h4>
                    <b-card-text class="xmb-0">
                      {{ item.title }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <b-card title="Filter">
        <b-row xl="12" sm="12">
          <b-col
            cols="12"
            md="2"
            class="mb-md-0 mb-2"
          >
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="ProvinceOptions" :reduce="ProvinceOptions => ProvinceOptions.value"
              id="v-Province" 
              v-model="select_6" 
              label="title"
              placeholder="--Select Province --"
              class="w-100"
            />
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="mb-md-0 mb-2"
          >
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="RegencyOptions" :reduce="RegencyOptions => RegencyOptions.value"
              v-model="select_7" 
              label="title"
              id="v-Regency" 
              placeholder="--Select Regency --"
              class="w-100"
            />
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="mb-md-0 mb-2" style="display:none;"
          >
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="DistrictOptions" :reduce="DistrictOptions => DistrictOptions.value"
              v-model="select_8" 
              id="v-District" 
              label="title"
              placeholder="--Select District --"
              class="w-100"
            />
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="mb-md-0 mb-2"
          >
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="DeviceTypeOptions" :reduce="DeviceTypeOptions => DeviceTypeOptions.value"
              v-model="select_9" 
              id="v-Device" 
              label="title"
              placeholder="--Select Device Type --"
              class="w-100"
            />
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="mb-md-0 mb-2"
          >
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="StatusDevices"
              :reduce="(StatusDevices) => StatusDevices.value"
              label="title"
              v-model="select_10"
              placeholder="Status"
              class="w-100"
            />
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="mb-md-0 mb-2"
          >
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="StatusConnectionDevices"
              :reduce="(StatusConnectionDevices) => StatusConnectionDevices.value"
              label="title"
              v-model="select_11"
              placeholder="Connection Status"
              class="w-100"
            />
          </b-col>
          <b-button class="sidebar-right ml-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'" @click="filters()" variant="outline-primary">
            <feather-icon icon="SearchIcon" /> Filter
          </b-button>  
        </b-row>
      </b-card>
      <b-card title="Device Location Map">
        <hr>
        <b-row xl="12" sm="12">
          <b-col
            cols="12"
            md="12"
            class="mb-md-0 mb-2"
          >
            <div id="map"></div><hr>
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="mb-md-0 mb-2"
          >
            <div class="d-flex justify-content-between flex-wrap">
              <!-- export excel  -->
              <div>
      <b-button class="ml-1 mb-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" @click="exportExcel">
        <feather-icon icon="DownloadIcon" /> Export
      </b-button>  
    </div>
              <!-- filter -->
              <b-form-group label="Filter" label-cols-sm="2" label-align-sm="left" label-size="sm" label-for="filterInput" class="mr-1" >
                <b-input-group size="sm">
                  <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Type to Search"/>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">
                      Clear
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
            <b-table striped hover responsive class="position-relative" :per-page="perPage" :current-page="currentPage" :items="items" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
              <template #cell(created_at)="data">
                {{ dateFormat(data.value) }}
              </template>
              <template #cell(value)="row">
                {{ `${Number(row.item.value).toFixed(2)} ${row.item.default_unit}` }}
              </template>
              <template #cell(serial_number)="row">
              <b-link
                :to="{ path: '/temperature-device/detail/' + row.item.id }"
              >
                <span>{{ row.item.serial_number }}</span>
              </b-link>
            </template>
              <template #cell(status)="data">
                <b-badge :variant="status[1][data.value]">
                  {{ status[0][data.value] }}
                </b-badge>
              </template>
              <template #cell(device_status_connection)="data">
                <b-badge :variant="device_status[1][data.value]">
                  {{ device_status[0][data.value] }}
                </b-badge>
              </template>
              <template #cell(smile_connection_status)="data">
                <b-badge :variant="StatusConnection[1][data.value]">
                  {{ StatusConnection[0][data.value] }}
                </b-badge>
              </template>
              <template #cell(last_send_data)="data">
                {{ formatRelativeTime(data.value) || '-' }}
              </template>
              <template #cell(action)="row">
                <span>
                  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                    <template v-slot:button-content>
                      <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                    </template>
                    <b-dropdown-item>
                      <b-link :to="{ path: '/location/detail/'+ row.item.id}">
                      <feather-icon icon="Edit2Icon" class="mr-50" />
                      <span>Edit</span>
                      </b-link>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      <b-link v-b-modal.modal-center
                      @click="rowOnDelete(row.item.id)">
                      <feather-icon icon="TrashIcon" class="mr-50" />
                      <span>Delete</span>
                      </b-link>
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
              </template>
            </b-table>
            <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
              <!-- page length -->
              <b-form-group label="Per Page" label-cols="6" label-align="left" label-size="sm" label-for="sortBySelect" class="text-nowrap mb-md-0 mr-1">
                <b-form-select id="perPageSelect" v-model="perPage" size="sm" inline :options="pageOptions" />
              </b-form-group>
              <!-- pagination -->
              <div>
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number prev-class="prev-item" next-class="next-item" class="mb-0">
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import { BPopover, BOverlay, BCard, BTable, BImg, BMedia, BAvatar, BCardText, BMediaAside, BMediaBody, BInputGroup, BInputGroupAppend, BCardBody, BLink,  BButton, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BRow, BCol, BDropdown, BDropdownItem } from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store/index'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import flatPickr from 'vue-flatpickr-component'
import apexChatData from './apexChartData'
import vSelect from 'vue-select'
import { $themeColors } from '@themeConfig'
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import useJwt from '@/auth/jwt/useJwt'
import XLSX from 'xlsx'
import { formatRelativeTime } from '@/store/utils'

// colors
const chartColors = {
  column: {
    series1: '#826af9',
    series2: '#d2b0ff',
    bg: '#f8d3ff',
  },
  success: {
    shade_100: '#7eefc7',
    shade_200: '#06774f',
  },
  donut: {
    series1: '#ffe700',
    series2: '#00d4bd',
    series3: '#826bf8',
    series4: '#2b9bf4',
    series5: '#FFA1A1',
  },
  area: {
    series3: '#a4f8cd',
    series2: '#60f2ca',
    series1: '#2bdac7',
  },
}
const getCurrentTime = () => moment(String(new Date())).format("dddd, DD MMM' YYYY LTS")
export default {
  components: { BPopover, BOverlay, vSelect, flatPickr, moment, VueApexCharts, BCard, BCardText, BMedia, BAvatar, BMediaAside, BMediaBody, BTable, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BRow, BCol, BDropdown, BDropdownItem, ToastificationContent},
  data () {
    return {
      perPage: 25,
      userData: JSON.parse(localStorage.getItem('userData')),
      show: false,
      map: null,
      tourStops: [],
      styledMapType: null,
      data: [
          {
            icons: require('@/assets/images/icons/online.png'),
            color: 'light-warning',
            title: 0,
            subtitle: 'Online',
            customClass: 'mb-2 mb-xl-1',
          },
          {
            icons: require('@/assets/images/icons/offline.png'),
            color: 'light-info',
            title: 0,
            subtitle: 'Offline',
            customClass: 'mb-2 mb-xl-1',
          },
          {
            icons: require('@/assets/images/icons/online.png'),
            color: 'light-warning',
            title: 0,
            subtitle: 'Connected',
            customClass: 'mb-2 mb-xl-1',
          },
          {
            icons: require('@/assets/images/icons/offline.png'),
            color: 'light-info',
            title: 0,
            subtitle: 'Disconnected',
            customClass: 'mb-2 mb-xl-1',
          },
          {
            icons: require('@/assets/images/icons/alarm.png'),
            icon: 'LayersIcon',
            color: 'light-primary',
            title: 0,
            subtitle: 'Alarm',
            customClass: 'mb-2 mb-sm-0',
          },
          {
            icons: require('@/assets/images/icons/site.png'),
            icon: 'DollarSignIcon',
            color: 'light-success',
            title: 0,
            subtitle: 'Site',
            customClass: 'mb-2 mb-sm-0',
          },
          {
            icons: require('@/assets/images/icons/offline.png'),
            icon: '',
            color: 'light-info',
            title: 0,
            subtitle: 'Error',
            customClass: 'mb-2 mb-xl-0',
          },
          {
            icons: require('@/assets/images/icons/site.png'),
            color: 'light-warning',
            title: 0,
            subtitle: 'Total',
            customClass: 'mb-2 mb-xl-0',
          }
        ],
      lineChartSimple: {
        series: [
          {
            name: "Flow Rate",
            data: [],
          },
          {
            name: "Totalizer",
            data: [],
          }
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ["#FF1654", "#247BA0"],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${
                data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            // opposite: isRtl,
          },
        },
      },
      apexChatData,
      datenow: moment(String(new Date())).format("dddd, DD MMM' YYYY LTS"),
      // datenow: moment(60 * 10 * 1000),
      date_start: moment(String(new Date())).format('YYYY-MM-DD HH:mm:ss'),
      date_finish: moment(String(new Date())).format('YYYY-MM-DD HH:mm:ss'),
      dir: false,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tagloc: null,
      select_6: '', select_7: '', select_8: '', select_9: '',select_10: '', select_11: '',
      weather:[],
      weather_name:null,
      weather_main:null,
      weather_description:null,
      weather_main_temp:null,
      weather_main_feels_like:null,
      weather_main_humidity:null,
      weather_cod:null,
      weather_main_pressure:null,
      weather_visibility:null,
      weather_data:[],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      statusFilter: 'ALL',
      status: [{
        AC: 'Active', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        AC: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      statusOptions: [
        { title: 'History', value: 'ALL' },
        { title: 'Realtime', value: 'AC' },
      ],
      StatusConnection: [
        {
          Connected: "Connected",
          Disconnected: "Disconnected"
        },
        {
          Disconnected: "light-warning",
          Connected: "light-success"
        }
      ],
      StatusDevices: [
        { title: 'Online', value: 'IN' },
        { title: 'Error', value: 'FL' },
        { title: 'Offline', value: 'ER' },
      ],
      StatusConnectionDevices: [
        { title: 'Connected', value: 'Connected' },
        { title: 'Disconnected', value: 'Disconnected' },
      ],
      status: [
        {
          FL: "Error",
          IN: "Online",
          ER: "Offline",
        },
        {
          FL: "light-warning",
          IN: "light-success",
          ER: "light-secondary",
        }
      ],
      device_status: [
        {
          ONLINE: 'Online',
          OFFLINE: 'Offline',
        },
        {
          ONLINE: 'light-success',
          OFFLINE: 'light-warning',
        },
      ],
      formatRelativeTime
    }
  },
  computed: {
    ...mapState({ 
      DeviceTypeOptions: state => state.temperature.devicetypeoptions,
      ProvinceOptions: state => state.region.province, 
      RegencyOptions: state => state.region.regency, 
      DistrictOptions: state => state.region.district,
      dashboard: state => state.temperature.dashboard, 
      totalRows: state => state.temperature.device_list.totalRows, 
      fields: state => state.temperature.device_list.fields, 
      items: state => state.temperature.device_list.items, 
      pageOptions: state => state.temperature.device_list.pageOptions, 
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
      .filter(f => f.sortable)
      .map(f => ({ text: f.label, value: f.key }))
    },
    dateFormat () {
      return create_at => this.$options.filters.formatDate(create_at)
    },
    direction () { 
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    }
  },
  watch: {
    select_6 (obj) {
      return this.$store.dispatch('region/regency', obj)
    },
    select_7 (obj) {
      return this.$store.dispatch('region/district', obj)
    },
    select_8 (obj) {
      return this.$store.dispatch('region/village', obj)
    }
  },
  methods: {
    exportExcel(evt) {
      let nameProject = ""
        useJwt.getProfile().then(response => {
              nameProject = response.data.data.project[0].project_name
          const jsons = []
          for (let y = 0; y < this.items.length; y++) {
              jsons[y] = {
                  'Project':nameProject,
                  'Site Name':this.items[y].site_name,
                  'Device Code':this.items[y].device_code,
                  'Serial Number':this.items[y].device_serial_number,
                  'Value':this.items[y].device_value + "°C",
                  'Last Send Data': this.items[y].last_send_data ? this.dateFormat(this.items[y].last_send_data) : '-',
                  'Status':this.items[y].device_status,
                  'Smile Connection Status':this.items[y].smile_connection_status
                }
              }
              const data_json = XLSX.utils.json_to_sheet(jsons)
              const wb = XLSX.utils.book_new()
              XLSX.utils.book_append_sheet(wb, data_json, 'data')
            	XLSX.writeFile(wb,nameProject +'.xlsx')
              })
            },
            updateCurrentTime() {
              this.datenow = getCurrentTime()
            },
            initMap(latittute,longtitude) {
              
            },
            info(item, index, button) {
              this.infoModal.title = `Row index: ${index}`
              this.infoModal.content = JSON.stringify(item, null, 2)
              this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            resetInfoModal() {
              this.infoModal.title = ''
              this.infoModal.content = ''
            },
            onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows = filteredItems.length
      this.currentPage = 1
    },
    advanceSearch (val) {
      this.searchTerm = val
    },
    setStatus (val) {
      if (val === 'IN'){
        return 'Online'
      } else if (val === 'ER') {
        return 'Offline'
      } else if (val === 'FL') {
        return 'Error'
      }
    },
    moment: function (date) {
      return moment(date)
    },
    filters() {
      if (!this.select_6) {
        this.select_6 = ''
      }
      if (!this.select_7) {
        this.select_7 = ''
      }
      if (!this.select_8) {
        this.select_8 = ''
      }
      this.params = {
        province_id: this.select_6,
        regency_id: this.select_7,
        district_id: this.select_8,
        device_type_id: this.select_9,
        device_status: this.select_10,
        connection_status: this.select_11
      }
      this.$store.dispatch('temperature/getDashboard', this.params).then(resp => {
        this.injectData(resp)
      })
    },
    injectData(resp) {
      this.data[0].title = resp.count.online
      this.data[1].title = resp.count.offline
      this.data[2].title = resp.count.connected
      this.data[3].title = resp.count.disconnected
      this.data[4].title = resp.count.alarm
      this.data[5].title = resp.count.site
      this.data[6].title = resp.count.error
      this.data[7].title = resp.count.online + resp.count.offline + resp.count.alarm + + resp.count.error
      this.weather = resp.weather
      var tourStops = []
      for (let x = 0; x < resp.device_map_location.length; x++) {
        tourStops[x] = [{
          site_id: resp.device_map_location[x].site_id,
          site_name: resp.device_map_location[x].site_name,
          area_id: resp.device_map_location[x].area_id,
          area_name: resp.device_map_location[x].area_name,
          location_id: resp.device_map_location[x].location_id,
          location_name: resp.device_map_location[x].location_name,
          device_id: resp.device_map_location[x].device_id,
          device_name: resp.device_map_location[x].device_name,
          device_alias: resp.device_map_location[x].device_alias,
          device_code: resp.device_map_location[x].device_code,
          device_value: resp.device_map_location[x].device_value,
          device_default_unit: resp.device_map_location[x].device_default_unit,
          device_status: this.setStatus(resp.device_map_location[x].device_status),
          device_description: resp.device_map_location[x].device_description,
          lat: parseFloat(resp.device_map_location[x].device_latitude),
          lng: parseFloat(resp.device_map_location[x].device_longitude)
        }]
      }
      this.tourStops=tourStops
      if (resp.weather) {
        this.weather_name = resp.weather.name
        this.weather_main = resp.weather.weather[0].main
        this.weather_description = resp.weather.weather[0].description
        this.weather_main_temp = resp.weather.main.temp
        this.weather_main_feels_like = resp.weather.main.feels_like
        this.weather_main_humidity = resp.weather.main.humidity
        this.weather_cod = resp.weather.cod
        this.weather_main_pressure = resp.weather.main.pressure
        this.weather_visibility = resp.weather.visibility
      }
      navigator.geolocation.getCurrentPosition((position) => {
        // this.initMap(position.coords.latitude, position.coords.longitude)
        this.show = false
        if (position) {
          const myLatlng = { lat: position.coords.latitude, lng: position.coords.longitude }
          this.styledMapType = new google.maps.StyledMapType(
            [
              {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [
                  { visibility: 'off' }
                ]
              }
            ],
            { name: 'Styled Map' }
          )
          const map = new window.google.maps.Map(document.getElementById('map'), {
              zoom: 7,
              center: myLatlng,
            }
          )
          let svgMarker = {
            path: "M14,7.5c0,3.5899-2.9101,6.5-6.5,6.5S1,11.0899,1,7.5S3.9101,1,7.5,1S14,3.9101,14,7.5z",
            fillColor: "",
            fillOpacity: 1,
            strokeWeight: 0,
            rotation: 0,
            scale: 1,
            anchor: new google.maps.Point(0, 20),
          }
          map.mapTypes.set('styled_map', this.styledMapType);
          
          map.setMapTypeId('styled_map');
          // Create an info window to share between markers.
          const infoWindow = new google.maps.InfoWindow();

          // Create the markers.
          const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          const markers = this.tourStops.map(([position, title], i) => {
            if (position.device_status === "Online") {
              svgMarker.fillColor = "#4CBB17";
            }if (position.device_status === "Offline") {
              svgMarker.fillColor = "#000000";
            }
            const marker = new google.maps.Marker({
              position,
              map: map,
              title: `
              Site Name : ${position.site_name} 
              Value : ${position.device_value} ${position.device_default_unit}
              Status : ${position.device_status}
              `,
              optimized: false,
              icon : svgMarker
            })
            marker.addListener('click', () => {
              infoWindow.setContent(marker.getTitle())
              infoWindow.open(marker.getMap(), marker)
            })
            return marker
          })
          new MarkerClusterer({ map, markers,
            renderer: {
            render: ({markers, _position: position}) => {
              const color = '#FF8202';
              // create svg url with fill color
              const svg = window.btoa(`
              <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
              <circle cx="120" cy="120" opacity=".6" r="70" />
              <circle cx="120" cy="120" opacity=".3" r="90" />
              <circle cx="120" cy="120" opacity=".2" r="110" />
              </svg>`);
              return new google.maps.Marker({
              position,
              icon: {
              url: `data:image/svg+xml;base64,${svg}`,
              scaledSize: new google.maps.Size(45, 45),
              },
              label: {
              text: String(markers.length),
              color: "rgba(255,255,255,0.9)",
              fontSize: "12px",
              },
              title: `Cluster of ${markers.length} markers`,
              // adjust zIndex to be above other markers
              zIndex: Number(google.maps.Marker.MAX_ZINDEX) + markers.length,
              });
            }
          }
          });
        }
      })
    }
  },
  directives: {
    Ripple
  },
  created () {
    this.show = true
    this.filters()
    setInterval(() => this.updateCurrentTime(), 1000)
    this.$store.dispatch('temperature/getDeviceType')
    this.$store.dispatch('region/province')
    this.$store.dispatch('site/getAll')
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style scoped>
    #map {
    height:600px;
    width: 100%;
   }
   .marker-cluster-small {
  background-color: #49afa5 !important;
}

.marker-cluster-small div {
  background-color: #1c9489 !important;
  color: #fff !important;
}
</style>
